"use client";

import { use, useRef } from "react";
import StoreBox from "../store/store-box";
import ProfilePage from "./profile-page";
import { useAppDispatch, useAppSelector } from "../slice/hooks";
import { useHistoryManager } from "../history/useHistoryManager";
import { setActiveCategory, setCategories } from "../slice/category-slice";
import {
  setAccessPoint,
  setAccessPointId,
  setAccessPoints,
  setOrganisation,
} from "../slice/accessOrg-slice";

const ProfileContainer = (props) => {
  const {
    fullUrlPath,
    loginSuccessHandler,
    organisation,
    accessPointId,
    storePath,
    cart,
    navLocation,
  } = props;

  // const storePath = useAppSelector((state) => state.path.storePath);
  // const cart = useAppSelector((state) => state.cart.activeCart);
  // const organisation = useAppSelector((state) => state.accessOrg.organisation);
  // const accessPoint = useAppSelector((state) => state.accessOrg.accessPoint);
  // const accessPoints = useAppSelector((state) => state.accessOrg.accessPoints);
  // const accessPointId = useAppSelector(
  //   (state) => state.accessOrg.accessPointId
  // );

  const scrollRef = useRef(null);
  const { navigateTo } = useHistoryManager();
  const dispatch = useAppDispatch();

  return (
    <>
      {navLocation === "marketplace" && (
        <div
          style={{
            backgroundColor: "#0e86d4",
            color: "white",
            padding: "1rem",
            cursor: "pointer",
          }}
          onClick={() => {
            navigateTo(
              "market-place/stores",
              {
                urlData: {
                  accessPoint: null,
                  accessPoints: [],
                  accessPointId: null,
                  organisation: null,
                },
                onNavigate: (navigate) => {
                  if (navigate) {
                    dispatch(setAccessPointId(null));
                    dispatch(setAccessPoint(null));
                    dispatch(setAccessPoints([]));
                    dispatch(setOrganisation(null));
                    dispatch(setActiveCategory(null));
                    dispatch(setCategories(null));
                  }
                },
              },
              false,
            );
          }}
        >
          <h2>Go to our MarketPlace.</h2>
        </div>
      )}
      <StoreBox
        {...props}
        handleLocationChange={() => {}}
        bodyClassName="profile-target"
      >
        <div className="profile-container" ref={scrollRef}>
          <ProfilePage
            storePath={storePath}
            cart={cart}
            fullUrlPath={fullUrlPath}
            organisation={organisation}
            accessPointId={accessPointId}
            parentScrollRef={scrollRef}
            handleLoginSuccess={loginSuccessHandler}
          />
        </div>
      </StoreBox>
    </>
  );
};

export default ProfileContainer;
